<template>
  <div>
    <button @click="showModal = true" class="btn--link">bounty contributions</button>

    <MtxModal v-model="showModal" @hide="$v.$reset()" class="text-left">
      <h3 class="text-center">Contributions</h3>

      <div v-if="tournament.round.status === 'open'" class="mb-3">
        <button v-if="!web3.ready" @click="requireWeb3()" class="btn--block">
          Sign in to contribute
        </button>

        <div v-else class="add-to-bounty__form grid grid-gap">
          <MtxInput
            v-model="addAmount"
            type="number"
            step="any"
            label="Add MTX to bounty"
            :validation="$v.addAmount"
            :description="`Cannot exceed your MTX balance: ${web3.mtxBalance}`"
            required
          ></MtxInput>

          <div class="mt-3">
            <button
              @click="requireWeb3(addToBounty)"
              :class="{ 'btn--disabled': $v.$invalid }"
              type="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <div class="px-4">
        <div
          v-for="(contribution, i) in tournament.contributions"
          :key="i"
          class="my-1 grid grid-2-columns"
        >
          <ProfileLink :address="contribution.contributor" />
          <div class="text-right">
            <strong>{{ contribution.amount | mtx }}</strong>
          </div>
        </div>
      </div>
    </MtxModal>
  </div>
</template>

<script>
import { required, between, decimal } from "@/utils/validators"
import MatryxTournament from "@/web3/contracts/MatryxTournament"
import web3 from "@/mixins/web3"

export default {
  mixins: [web3],

  props: {
    tournament: Object
  },

  data: () => ({
    addAmount: null,
    showModal: false
  }),

  methods: {
    async addToBounty() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.showModal = false

      const Tournament = new MatryxTournament(
        this.tournament.address,
        this.contracts.artifacts.tournament.abi
      )

      const tx = this.addPlannedTx({
        txFn: () => Tournament.addToBounty(this.addAmount),
        allowance: +this.addAmount,
        header: "Add to bounty",
        body: `This will transfer ${this.addAmount} MTX from your wallet to this tournament.`
      })

      try {
        await tx
        this.$emit("chaChing", this.addAmount)
      } finally {
        this.addAmount = null
      }
    }
  },

  validations() {
    return {
      addAmount: {
        required,
        between: between(1e-18, this.web3.mtxBalance),
        decimal
      }
    }
  }
}
</script>

<style lang="scss">
.add-to-bounty__form {
  grid-template-columns: 1fr auto;
}
</style>
